'use strict';

let _SERVICES_HOST = process.env.SERVICES_HOST || 'https://services.testim.io';
export const DEFAULT_EDITOR_URL = 'https://app.testim.io';
if (process.env.GATEWAY_URL) {
    process.env.SERVICES_HOST = `${process.env.GATEWAY_URL}/testim/services`;
    // set the services for the extension
    process.env.EXTENSION_SERVICES_HOST = process.env.TUNNEL_GATEWAY ? process.env.SERVICES_HOST : _SERVICES_HOST;
    _SERVICES_HOST = process.env.SERVICES_HOST;
}

type TestimRegion = 'us-west-2' | 'eu-central-1';
export const TESTIM_REGION: TestimRegion = (process.env.TESTIM_REGION as TestimRegion) || 'us-west-2';

type TRunnerEnvironment = 'development' | 'staging' | 'production';
export const RUNNER_ENVIRONMENT: TRunnerEnvironment =
    (process.env.RUNNER_ENVIRONMENT as TRunnerEnvironment) || 'production';

const ENV_DOMAIN_SUFFIX = {
    production: '',
    staging: '.staging',
    development: '.dev',
};
export const EXTENSION_SP_S3_HOST =
    process.env.EXTENSION_SP_S3_HOST ||
    `https://playback-components${ENV_DOMAIN_SUFFIX[RUNNER_ENVIRONMENT as unknown as keyof typeof ENV_DOMAIN_SUFFIX] || ''}.testim.io`;

export const DISABLE_AGENT_ORIGIN_CHECK = parseInt(process.env.DISABLE_AGENT_ORIGIN_CHECK || '0', 10);
export const DISABLE_DEBUGGER_INFINITE_TIMEOUT = parseInt(process.env.DISABLE_DEBUGGER_INFINITE_TIMEOUT || '0', 10);
export const OVERRIDE_TIMEOUTS = parseInt(process.env.OVERRIDE_TIMEOUTS || '0', 10);
export const EDITOR_URL = process.env.EDITOR_URL;
export const WEBSOCKET_HOST = process.env.WEBSOCKET_HOST || `${_SERVICES_HOST}/ws`;
export const SERVICES_HOST = () => _SERVICES_HOST;
export const LOGGER_CONSOLE = parseInt(process.env.LOGGER_CONSOLE || '0', 10);
export const LOGGER_DEBUG = parseInt(process.env.LOGGER_DEBUG || '0', 10);
export const WEBDRIVER_DEBUG = parseInt(process.env.WEBDRIVER_DEBUG || '0', 10);
export const IS_ON_PREM = parseInt(process.env.IS_ON_PREM || '0', 10);
export const REQUESTS_QUEUE_SIZE = process.env.REQUESTS_QUEUE_SIZE
    ? parseInt(process.env.REQUESTS_QUEUE_SIZE, 10)
    : undefined;
export const DEBUG_MODE = parseInt(process.env.DEBUG_MODE || '0', 10);
export const TESTIM_CONCURRENT_WORKER_COUNT = process.env.TESTIM_CONCURRENT_WORKER_COUNT
    ? parseInt(process.env.TESTIM_CONCURRENT_WORKER_COUNT, 10)
    : null;
export const ROLLOUT_KEY = process.env.ROLLOUT_KEY || '5b5560729601aa6484276518';

// Better Stack logging
export const BETTERSTACK_INGEST_URL_US = process.env.BETTERSTACK_INGEST_URL_US || 'https://s1764893.us-east-9.betterstackdata.com';
export const BETTERSTACK_TOKEN_US = process.env.BETTERSTACK_TOKEN_US || 'hZwS8Qt91YwDSDSK6CGicabR';
export const BETTERSTACK_INGEST_URL_EU = process.env.BETTERSTACK_INGEST_URL_EU || '';
export const BETTERSTACK_TOKEN_EU = process.env.BETTERSTACK_TOKEN_EU || '';
export const DF_ENABLE_VIDEO = parseInt(process.env.DF_ENABLE_VIDEO || '0', 10);
export const APPIUM_VERSION = process.env.APPIUM_VERSION || '1.10.1';
export const GATEWAY_URL = process.env.GATEWAY_URL;
export const EXTENSION_SERVICES_HOST = () => process.env.EXTENSION_SERVICES_HOST || _SERVICES_HOST;

export const APP_UPLOAD_TIMEOUT = 5 * 60 * 1000;
export const MINIMUM_KNOWN_UPLOAD_SPEED_PER_SECONDS = 40;

// Tricentis Device Cloud
export const TDC_MOBILE_API_BASE_URL = process.env.TDC_MOBILE_API_BASE_URL || 'https://api.tdc.tricentis-cloud.com';
export const TDC_DEVICES_API_PATH = process.env.TDC_DEVICES_API_PATH || 'v0';
export const TDC_APPS_API_PATH = process.env.TDC_APPS_API_PATH || 'v1';

// Tricentis Virtual Cloud or Virtual Mobile Cloud (VMG)
export const TVC_MOBILE_API_URL = process.env.TVC_MOBILE_API_URL || 'https://api.waldo.com';

export const BROWSERSTACK_MOBILE_API_URL =
    process.env.BROWSERSTACK_APPS_API_URL || 'https://api-cloud.browserstack.com/app-automate';

export const setServicesHost = (host: string) => {
    _SERVICES_HOST = host;
    process.env.SERVICES_HOST = host;
    process.env.EXTENSION_SERVICES_HOST = process.env.TUNNEL_GATEWAY ? process.env.SERVICES_HOST : _SERVICES_HOST;
};
